var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect3, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 588,
  height: 804,
  viewBox: "0 0 588 804",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 588,
  height: 804,
  rx: 12,
  fill: "black",
  fillOpacity: 0.05
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M99 28C101.209 28 103 29.7909 103 32V38C103 40.2091 101.209 42 99 42H32C29.7909 42 28 40.2091 28 38V32C28 29.7909 29.7909 28 32 28H99Z",
  fill: "black",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M98.6341 58C100.843 58 102.634 59.7909 102.634 62V66C102.634 68.2091 100.843 70 98.6341 70H32C29.7909 70 28 68.2091 28 66V62C28 59.7909 29.7909 58 32 58H98.6341Z",
  fill: "black",
  fillOpacity: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M122.78 105C124.99 105 126.78 106.791 126.78 109V121C126.78 123.209 124.99 125 122.78 125H32C29.7909 125 28 123.209 28 121V109C28 106.791 29.7909 105 32 105H122.78Z",
  fill: "black",
  fillOpacity: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M294 79C296.209 79 298 80.7909 298 83V95C298 97.2091 296.209 99 294 99H32C29.7909 99 28 97.2091 28 95V83C28 80.7909 29.7909 79 32 79H294Z",
  fill: "black",
  fillOpacity: 0.1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M289.61 174C291.819 174 293.61 175.791 293.61 178V184C293.61 186.209 291.819 188 289.61 188H32C29.7909 188 28 186.209 28 184V178C28 175.791 29.7909 174 32 174H289.61Z",
  fill: "black",
  fillOpacity: 0.1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M266.561 156C268.77 156 270.561 157.791 270.561 160V166C270.561 168.209 268.77 170 266.561 170H32C29.7909 170 28 168.209 28 166V160C28 157.791 29.7909 156 32 156H266.561Z",
  fill: "black",
  fillOpacity: 0.1
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M277.537 138C279.746 138 281.537 139.791 281.537 142V148C281.537 150.209 279.746 152 277.537 152H32C29.7909 152 28 150.209 28 148V142C28 139.791 29.7909 138 32 138H277.537Z",
  fill: "black",
  fillOpacity: 0.1
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M106.317 198C108.526 198 110.317 199.791 110.317 202V206C110.317 208.209 108.526 210 106.317 210H32C29.7909 210 28 208.209 28 206V202C28 199.791 29.7909 198 32 198H106.317Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 58,
  width: 246,
  height: 164,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M98.6341 241C100.843 241 102.634 242.791 102.634 245V249C102.634 251.209 100.843 253 98.6341 253H32C29.7909 253 28 251.209 28 249V245C28 242.791 29.7909 241 32 241H98.6341Z",
  fill: "black",
  fillOpacity: 0.1
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M122.78 288C124.99 288 126.78 289.791 126.78 292V304C126.78 306.209 124.99 308 122.78 308H32C29.7909 308 28 306.209 28 304V292C28 289.791 29.7909 288 32 288H122.78Z",
  fill: "black",
  fillOpacity: 0.1
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M294 262C296.209 262 298 263.791 298 266V278C298 280.209 296.209 282 294 282H32C29.7909 282 28 280.209 28 278V266C28 263.791 29.7909 262 32 262H294Z",
  fill: "black",
  fillOpacity: 0.1
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M289.61 357C291.819 357 293.61 358.791 293.61 361V367C293.61 369.209 291.819 371 289.61 371H32C29.7909 371 28 369.209 28 367V361C28 358.791 29.7909 357 32 357H289.61Z",
  fill: "black",
  fillOpacity: 0.1
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M266.561 339C268.77 339 270.561 340.791 270.561 343V349C270.561 351.209 268.77 353 266.561 353H32C29.7909 353 28 351.209 28 349V343C28 340.791 29.7909 339 32 339H266.561Z",
  fill: "black",
  fillOpacity: 0.1
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M277.537 321C279.746 321 281.537 322.791 281.537 325V331C281.537 333.209 279.746 335 277.537 335H32C29.7909 335 28 333.209 28 331V325C28 322.791 29.7909 321 32 321H277.537Z",
  fill: "black",
  fillOpacity: 0.1
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M106.317 381C108.526 381 110.317 382.791 110.317 385V389C110.317 391.209 108.526 393 106.317 393H32C29.7909 393 28 391.209 28 389V385C28 382.791 29.7909 381 32 381H106.317Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 241,
  width: 246,
  height: 164,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M92 432C94.2091 432 96 433.791 96 436V440C96 442.209 94.2091 444 92 444H32C29.7909 444 28 442.209 28 440V436C28 433.791 29.7909 432 32 432H92Z",
  fill: "black",
  fillOpacity: 0.1
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M556 453C558.209 453 560 454.791 560 457V467C560 469.209 558.209 471 556 471H32C29.7908 471 28 469.209 28 467V457C28 454.791 29.7909 453 32 453H556Z",
  fill: "black",
  fillOpacity: 0.1
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M139 481C141.209 481 143 482.791 143 485V489C143 491.209 141.209 493 139 493H32C29.7909 493 28 491.209 28 489V485C28 482.791 29.7909 481 32 481H139Z",
  fill: "black",
  fillOpacity: 0.1
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M92 520C94.2091 520 96 521.791 96 524V528C96 530.209 94.2091 532 92 532H32C29.7909 532 28 530.209 28 528V524C28 521.791 29.7909 520 32 520H92Z",
  fill: "black",
  fillOpacity: 0.1
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M556 541C558.209 541 560 542.791 560 545V555C560 557.209 558.209 559 556 559H32C29.7908 559 28 557.209 28 555V545C28 542.791 29.7909 541 32 541H556Z",
  fill: "black",
  fillOpacity: 0.1
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M139 569C141.209 569 143 570.791 143 573V577C143 579.209 141.209 581 139 581H32C29.7909 581 28 579.209 28 577V573C28 570.791 29.7909 569 32 569H139Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgImgPlaceholder;